import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrganizationStructureService } from '../../services/organization-structure.service';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { finalize } from 'rxjs/operators';
import { routes } from '@app/consts';

@Component({
  selector: 'new-organization-form-dialog',
  templateUrl: './new-organization-form-dialog.component.html',
  styleUrls: ['./new-organization-form-dialog.component.scss']
})
export class NewOrganizationFormDialogComponent implements OnInit {
  formId: string = 'frm_qK0FYWUEQe7FOz';
  getFormData: boolean = false;
  formValid: boolean = false;
  formData: any;

  constructor(
    private dialogRef: MatDialogRef<NewOrganizationFormDialogComponent>,
    private organizationService: OrganizationStructureService,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    public router: Router,
  ) { }

  ngOnInit(): void {
  }

  formDataEmitted(formData) {
    this.save(formData);
  }

  formStatusUpdated(formValid) {
    this.formValid = formValid;
  }

  save(formData) {
    this.formData = formData
    
    formData.name =  formData.localizations;
    formData.parentOrganization = formData.parentOrganization ? formData.parentOrganization.id : null ;

    this.organizationService.createOrganization(formData)
    .pipe(
      finalize(()=>{ 
        this.overlayService.hide();
      })
    )
    .subscribe(
      (res) => {
        this.snackbarService.openSnackBar('Organization created successfully', 'clear', 'success');
        this.close(res);
      }
    );
    
  }

  close(payload?:any){
    this.dialogRef.close({result: payload, formData : this.formData});
  }

}
